











import Vue from 'vue';

export default Vue.extend({
  name: 'ReferenceToggleModal',
  props: {
    headerText: {
      type: String,
      required: true
    },
    references: {
      type: Array,
      required: true
    },
    selectedReferences: {
      type: Array,
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      selected: this.selectedReferences.map((x: any) => x.value)
    };
  },
  computed: {
    buttonText(this: any) {
      return this.selectedReferences.length
        ? `Edit References (${this.selectedReferences.length})`
        : 'Select References';
    }
  },
  methods: {
    onOk(this: any) {
      this.$emit(
        'references-selected',
        this.references.filter((reference: any) => this.selected.includes(reference.value))
      );
    },
    onHide(this: any) {
      this.selected = this.selectedReferences.map((x: any) => x.value);
    }
  },
  watch: {
    selectedReferences(this: any) {
      this.selected = this.selectedReferences.map((x: any) => x.value);
    }
  }
});
